import type { GameDialogDefaultValues, GameStateMeta, MissingGame } from '../../../../types/features/games';
import { derivePricePerPack } from '../../details/mappers/gameDialogMappers';

export const createMissingGameDialogDefaultValues = (
  game: MissingGame,
  stateMeta?: GameStateMeta,
): GameDialogDefaultValues => {
  const ticketsPerPack = game.tickets_per_pack?.toString() || '';
  const costPerTicket = game.price_point || '';

  return {
    country_code: stateMeta?.country_code || '',
    country_name: stateMeta?.country_name || '',
    state_code: game.state,
    state_name: stateMeta?.state.state_name || '',
    game_id: game.game_id,
    plu: game.generated_plu || '',
    tickets_per_pack: ticketsPerPack,
    price_per_pack: derivePricePerPack(ticketsPerPack, costPerTicket),
    cost_per_ticket: costPerTicket,
    pending_plu_verification: true,
  };
};
